import { cva } from "class-variance-authority";
//#region src/components/RadioGroup/styles.ts
/** The radio's circle: shape and checked state, shared by the form `Radio` and the menu radio. */
const radioCircleVariants = cva([
	"tw:shrink-0",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:size-4",
	"tw:rounded-full",
	"tw:border",
	"tw:border-solid"
], {
	defaultVariants: { variant: "default" },
	variants: { variant: {
		default: ["tw:data-[state=checked]:border-primary", "tw:data-[state=unchecked]:border-neutral-200"],
		argo: [
			"tw:border-input",
			"tw:transition-colors",
			"tw:data-[state=checked]:bg-primary",
			"tw:data-[state=checked]:border-primary"
		]
	} }
});
/** The form `Radio`'s button states, layered on `radioCircleVariants`. */
const radioVariants = cva([
	"tw:bg-transparent",
	"tw:p-0",
	"tw:peer",
	"tw:cursor-pointer",
	"tw:whitespace-nowrap",
	"tw:disabled:cursor-not-allowed"
], {
	defaultVariants: { variant: "default" },
	variants: { variant: {
		default: [
			"tw:disabled:opacity-40",
			"tw:data-[state=unchecked]:hover:border-primary",
			"tw:data-[state=unchecked]:disabled:hover:border-neutral-200",
			"tw:focus-visible:ring-2",
			"tw:focus-visible:ring-ring/30"
		],
		argo: [
			"tw:disabled:opacity-50",
			"tw:data-[state=unchecked]:not-disabled:hover:bg-accent",
			"tw:data-[state=checked]:not-disabled:hover:bg-primary",
			"tw:focus-visible:outline-hidden",
			"tw:focus-visible:border-primary",
			"tw:focus-visible:ring-2",
			"tw:focus-visible:ring-ring/50"
		]
	} }
});
const radioIndicatorVariants = cva(["tw:size-2.5", "tw:fill-current"], {
	defaultVariants: { variant: "default" },
	variants: { variant: {
		default: ["tw:text-primary"],
		argo: ["tw:text-primary-foreground"]
	} }
});
const radioItemButtonVariants = cva([
	"tw:bg-transparent",
	"tw:p-0",
	"tw:peer",
	"tw:cursor-pointer",
	"tw:whitespace-nowrap",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:disabled:cursor-not-allowed",
	"tw:w-full",
	"tw:px-2",
	"tw:py-1.5",
	"tw:uppercase",
	"tw:font-semibold",
	"tw:font-sans",
	"tw:text-[11px]",
	"tw:whitespace-nowrap",
	"tw:tracking-widest",
	"tw:leading-[18px]",
	"tw:border",
	"tw:border-solid",
	"tw:rounded"
], {
	defaultVariants: { variant: "default" },
	variants: { variant: {
		default: [
			"tw:disabled:opacity-40",
			"tw:text-secondary-600",
			"tw:border-secondary-500",
			"tw:data-[state=unchecked]:hover:bg-secondary-500",
			"tw:data-[state=unchecked]:hover:text-white",
			"tw:data-[state=unchecked]:disabled:hover:bg-white",
			"tw:data-[state=unchecked]:disabled:hover:text-secondary-500",
			"tw:data-[state=checked]:disabled:cursor-not-allowed",
			"tw:data-[state=unchecked]:bg-white",
			"tw:data-[state=checked]:bg-secondary-500",
			"tw:data-[state=checked]:text-white",
			"tw:data-[state=checked]:cursor-default",
			"tw:focus-visible:outline",
			"tw:focus-visible:outline-ring",
			"tw:focus-visible:ring-4",
			"tw:focus-visible:ring-ring/30"
		],
		argo: [
			"tw:disabled:opacity-50",
			"tw:text-foreground",
			"tw:border-input",
			"tw:transition-colors",
			"tw:data-[state=unchecked]:bg-muted",
			"tw:data-[state=unchecked]:not-disabled:hover:bg-accent",
			"tw:data-[state=unchecked]:not-disabled:hover:text-accent-foreground",
			"tw:data-[state=checked]:bg-primary",
			"tw:data-[state=checked]:border-primary",
			"tw:data-[state=checked]:text-primary-foreground",
			"tw:data-[state=checked]:not-disabled:cursor-default",
			"tw:focus-visible:outline-hidden",
			"tw:focus-visible:border-primary",
			"tw:focus-visible:ring-2",
			"tw:focus-visible:ring-ring/50"
		]
	} }
});
//#endregion
export { radioCircleVariants, radioIndicatorVariants, radioItemButtonVariants, radioVariants };

//# sourceMappingURL=styles-DBGXH5-_.js.map